import { OdataAttribute } from '../types/odata-attribute.type';

export function createEqFilter(odataAttrib: OdataAttribute, value: any) {
  if (odataAttrib.type == 'Edm.Guid') {
    return {
      [odataAttrib.name]: { eq: { type: 'guid', value } },
    };
  } else {
    return {
      [odataAttrib.name]: value,
    };
  }
}

export function createEqFilterInCollection(
  odataAttrib: string,
  nestedAttrib: string,
  value: any,
  attribType: string
) {
  let filterValue = value;
  if (attribType === 'Edm.Guid') {
    filterValue = { eq: { type: 'guid', value } };
  }
  // e.g. Solutions/any(sol: sol/SolutionId eq 8dffe181-6c83-ec11-a507-00155da3d962)
  const filter = {
    [odataAttrib]: {
      any: {
        [nestedAttrib]: filterValue,
      },
    },
  };

  return filter;
}
